import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { useEffect, useState } from "react";

export default function ModalAddNew(props) {
    const { refresh, setRefresh, user } = props
    const [listCampaign, setListCampaign] = useState([])

    const [showModalImport, setShowModalImport] = useState(false)

    const formik = useFormik({
        initialValues: {},
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            fullname: Yup.string().trim().nullable().required('Nhập họ tên').max(150, "Độ dài không quá 150 ký tự"),
            contact: Yup.string().trim().nullable().required('Nhập số điện thoại').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            Axios.post(URL_LIST_ALL + 'leads', values, user.config).then(res => {
                if (res.data.status == 'success') {
                    setSubmitting(false);
                    resetForm();
                    alert("Thêm mới thành công")
                    setRefresh(!refresh)
                    
                }else{
                    alert(res.data.message)
                }
            }).catch(err => console.log(err));
        },
    });

    useEffect(
        function () {
            let mounted = true;
            Axios.get(URL_LIST_ALL + "campaign?status=1", user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListCampaign(res.data.data);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);

        }, [user]
    );

    return <>
        <button type="button" className="btn btn-sm btn-outline-primary ml-2" onClick={() => setShowModalImport(!showModalImport)}>Thêm mới</button>
        <Modal
            className="modal-customer-detail"
            show={showModalImport}
            onHide={() => setShowModalImport(false)}
            animation={true}
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Thêm mới khách hàng
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12 form-group mt-2">
                            <label>Họ và tên <span className="text-danger">*</span></label>
                            <input type="text" placeholder="Nhập họ tên" className="form-control height32" {...formik.getFieldProps("fullname")} />
                        </div>
                        <div className="col-12 col-sm-6 form-group ">
                            <label>Số điện thoại <span className="text-danger">*</span></label>
                            <input type="text" placeholder="Nhập số điện thoại" className="form-control height32" {...formik.getFieldProps("contact")} />
                        </div>
                        <div className="col-12 col-sm-6 form-group ">
                            <label>Email</label>
                            <input placeholder="VD: abc@domain.com" type="text" className="form-control height32" {...formik.getFieldProps("email")} />
                        </div>
                        <div className="col-12 col-sm-6 form-group ">
                            <label>Nguồn</label>
                            <input placeholder="VD: Facebook ADS" type="text" className="form-control height32" {...formik.getFieldProps("source")} />
                        </div>
                        <div className="col-12 col-sm-6 form-group ">
                            <label>Thẻ</label>
                            <input placeholder="VD: Thấp tầng" type="text" className="form-control height32" {...formik.getFieldProps("tags")} />
                        </div>
                        <div className="col-12 form-group">
                            <label>Thuộc chiến dịch: </label>
                            <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("campaign_id")}>
                                <option value="0" >Chọn chiến dịch</option>
                                {listCampaign.map((item) => <option value={item.id} key={item.id} >{item.title}</option>)}
                            </select>
                        </div>
                       
                        <div className="mt-3">
                            <button type="submit" disabled={formik.isSubmitting} className="btn btn-success mr-2">{formik.isSubmitting ? <div className="loader"></div> : <>Thêm mới</>}</button>
                            <button type="reset" onClick={formik.resetForm} className="btn btn-warning">Nhập lại</button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    </>
}